import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component DiscussionAddIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <DiscussionAddIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <DiscussionAddIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const DiscussionAddIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="DiscussionAddIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M22 13v9l-4-4H8a2 2 0 0 1-1.995-1.85L6 16v-1h10a3 3 0 0 0 2.829-2zM12 2v2H4v8.17L5.17 11H16l.001 1.732a2 2 0 0 1-.82.26L15 13H6l-4 4V4a2 2 0 0 1 1.85-1.995L4 2zm7 0v3h3v2h-3v3h-2V6.999L14 7V5l3-.001V2z"
      />
    </svg>
  )
);
DiscussionAddIcon.displayName = "DiscussionAddIcon";
export default DiscussionAddIcon;
